import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import enCommon from './locales/en/common.json';
import enPrayerRequest from './locales/en/prayerRequest.json';
import enAbout from './locales/en/about.json';
import enContact from './locales/en/contact.json';
import enFooter from './locales/en/footer.json';
import enLabels from './locales/en/labels.json';
import enGallery from './locales/en/gallery.json';
   

import esCommon from './locales/es/common.json';
import esPrayerRequest from './locales/es/prayerRequest.json';
import esAbout from './locales/es/about.json';
import esContact from './locales/es/contact.json';
import esFooter from './locales/es/footer.json';
import esLabels from './locales/es/labels.json';
import esGallery from './locales/es/gallery.json';

import svCommon from './locales/sv/common.json';
import svPrayerRequest from './locales/sv/prayerRequest.json';
import svAbout from './locales/sv/about.json';
import svContact from './locales/sv/contact.json';
import svFooter from './locales/sv/footer.json';
import svLabels from './locales/sv/labels.json';
import svGallery from './locales/sv/gallery.json';
import svBishops from './locales/sv/bishops.json';
import svMenuGuest from './locales/sv/menuGuest.json';

import deCommon from './locales/de/common.json';
import dePrayerRequest from './locales/de/prayerRequest.json';
import deAbout from './locales/de/about.json';
import deContact from './locales/de/contact.json';
import deFooter from './locales/de/footer.json';
import deLabels from './locales/de/labels.json';
import deGallery from './locales/de/gallery.json';
import deBishops from './locales/de/bishops.json';
import deMenuGuest from './locales/de/menuGuest.json';


i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        common: enCommon,
        prayerRequest: enPrayerRequest,
        about: enAbout,
        contact: enContact,
        footer: enFooter,
        labels: enLabels,
        gallery: enGallery,
      },
      es: {
        common: esCommon,
        prayerRequest: esPrayerRequest,
        about: esAbout,
        contact: esContact,
        footer: esFooter,
        labels: esLabels,
        gallery: esGallery,
      },
      sv: {
        common: svCommon,
        prayerRequest: svPrayerRequest,
        about: svAbout,
        contact: svContact,
        footer: svFooter,
        labels: svLabels,
        gallery: svGallery,
        bishops: svBishops,
        menuGuest: svMenuGuest,
      },
      de: {
        common: deCommon,
        prayerRequest: dePrayerRequest,
        about: deAbout,
        contact: deContact,
        footer: deFooter,
        labels: deLabels,
        gallery: deGallery,
        bishops: deBishops,
        menuGuest: deMenuGuest,
      },
    },
    supportedLngs: ['en', 'es', 'sv', 'de'],
    fallbackLng: 'en',
    detection: {
      order: ['navigator', 'htmlTag', 'path', 'subdomain', 'localStorage', 'cookie'],
      caches: ['localStorage', 'cookie'],
      lookupLocalStorage: 'i18nextLng',
      lookupCookie: 'i18next',
    },
    ns: ['common', 'prayerRequest', 'about', 'contact', 'footer', 'labels', 'gallery', 'bishops', 'menuGuest'],
    defaultNS: 'common',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
